/**
 * Sneltoets-hulp. Opent op `?` (geregistreerd in ThreadList), sluit op Esc
 * of klik buiten de modal.
 */

import { useEffect } from 'react';

const SHORTCUTS: Array<{ keys: string[]; description: string }> = [
  { keys: ['↑', '↓'], description: 'Navigeren door de lijst' },
  { keys: ['j', 'k'], description: 'Navigeren door de lijst (vi-stijl)' },
  { keys: ['Enter'], description: 'Gesprek openen' },
  { keys: ['D'], description: 'AI-draft in composer laden' },
  { keys: ['⌘', 'Enter'], description: 'Antwoord versturen' },
  { keys: ['E'], description: 'Afhandelen' },
  { keys: ['I'], description: 'In behandeling' },
  { keys: ['⌘', 'I'], description: 'Klantinfo tonen/verbergen' },
  { keys: ['Esc'], description: 'Gesprek sluiten / veld verlaten' },
  { keys: ['?'], description: 'Deze hulp tonen' },
];

export function ShortcutHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold text-slate-900">Sneltoetsen</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600"
            title="Sluiten (Esc)"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-2">
          {SHORTCUTS.map((s) => (
            <div key={s.description} className="flex items-center justify-between text-sm">
              <span className="text-slate-600">{s.description}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k) => (
                  <kbd
                    key={k}
                    className="px-1.5 py-0.5 bg-slate-100 border border-slate-200 rounded text-xs font-medium text-slate-700 min-w-[1.5rem] text-center"
                  >
                    {k}
                  </kbd>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
